import React from 'react';
import Grid from '@mui/material/Grid2';
import Skeleton from '@mui/material/Skeleton';
import { BoxCenterStart } from '../style/box';
import { commonStyles } from '../style/common';

const SkeletonLoading = () => {
  return (
    <BoxCenterStart sx={commonStyles.page}>
      <Grid container spacing={7} columns={12} sx={commonStyles.container}>
        <Grid size={{ xs: 12 }}><Skeleton variant="rounded" height="5rem" animation="wave"/></Grid>
        <Grid size={{ xs: 12 }}><Skeleton variant="rounded" height="5rem" animation="wave"/></Grid>
        <Grid size={{ xs: 12 }}><Skeleton variant="rounded" height="10rem" animation="wave"/></Grid>
        <Grid size={{ xs: 12 }}><Skeleton variant="rounded" height="20rem" animation="wave"/></Grid>
      </Grid>
    </BoxCenterStart>
  );
};

export default SkeletonLoading;